import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
const SendEmail = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('information')}</h4>
            <p> {props.t('success_sending_memo')} !</p>
        </div>
    )
}

SendEmail.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SendEmail);